<template>
  <b-card>
    <validation-observer ref="institutionLimitRules">
      <b-form @submit.prevent="saveInstitutionLimit">

        <app-collapse
          class="business-items mb-4"
          type="margin"
          accordion
        >
          <app-collapse-item
            :title="$t('CARD LIMITS')"
            class="card-item"
            is-visible
          >
            <div class="d-flex">
              <h6 class="section-label mb-1 mt-0 sub-menu-title">
                {{ $t('Maximum ATM Transaction Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewATMTransactionLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="limit-per-transaction"
                    v-model.number="institutionLimitFormData.atM_Single_Withdrawal_Limit"
                    :label="`${$t('Limit Per Transaction - (Regulatory limit:')} ${toBalance(regulatoryLimitList.atM_Single_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    :rules="`required|amount-limit:${regulatoryLimitList.atM_Single_Withdrawal_Limit}|positive`"
                    :readonly="isReadonly"
                    @input="setATMCardLimit"
                  />
                </ValidationObserver>
              </b-col>

              <b-col md="6">
                <InputField
                  id="daily-transaction-count"
                  v-model="institutionLimitFormData.atM_Daily_Withdrawal_Count"
                  :label="$t('Daily Transaction Count')"
                  :placeholder="$t('Enter Daily Transaction Count')"
                  type="number"
                  :error-name="$t('Daily Transaction Count')"
                  rules="required|positive"
                  :readonly="isReadonly"
                  @input="setATMCardCount"
                />
              </b-col>

              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model="institutionLimitFormData.atM_Daily_Withdrawal_Limit"
                    :label="`${$t('Daily Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.atM_Daily_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Daily Transaction limit')"
                    :error-name="$t('Daily Transaction limit')"
                    :rules="`required|amount-limit:${regulatoryLimitList.atM_Daily_Withdrawal_Limit}|positive`"
                    readonly
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="weekly-transaction-limit"
                    v-model="institutionLimitFormData.atM_Weekly_Withdrawal_Limit"
                    :label="`${$t('Weekly Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.atM_Weekly_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Weekly Transaction limit')"
                    :error-name="$t('Weekly Transaction limit')"
                    :readonly="isReadonly"
                    :rules="`required|amount-limit:${regulatoryLimitList.atM_Weekly_Withdrawal_Limit}|positive`"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>

            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Customer ATM Default Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewCustomerATMDefaultLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="default-atm-single-withdrawal"
                    v-model.number="institutionLimitFormData.default_Customer_ATM_Single_Withdrawal_Limit"
                    :label="`${$t('Limit Per Transaction - (Regulatory limit:')} ${toBalance(regulatoryLimitList.atM_Single_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    :rules="`required|amount-limit:${regulatoryLimitList.atM_Single_Withdrawal_Limit}|default-atm-check:${institutionLimitFormData.atM_Single_Withdrawal_Limit}|positive`"
                    :readonly="isReadonly"
                    @input="setATMDefaultCardLimit"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="daily-transaction-count"
                    v-model="institutionLimitFormData.default_Customer_ATM_Daily_Withdrawal_Count"
                    :label="$t('Daily Transaction Count')"
                    :placeholder="$t('Enter Daily Transaction Count')"
                    type="number"
                    :error-name="$t('Daily Transaction Count')"
                    :rules="`required|positive|default-atm-check:${institutionLimitFormData.atM_Daily_Withdrawal_Count}`"
                    :readonly="isReadonly"
                    @input="setATMDefaultCardCount"
                  />
                </ValidationObserver>
              </b-col>

              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model="institutionLimitFormData.default_Customer_ATM_Daily_Withdrawal_Limit"
                    :label="`${$t('Daily Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.atM_Daily_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Daily Transaction limit')"
                    :error-name="$t('Daily Transaction limit')"
                    :rules="`required|amount-limit:${regulatoryLimitList.atM_Daily_Withdrawal_Limit}|default-atm-check:${institutionLimitFormData.atM_Daily_Withdrawal_Limit}|positive`"
                    readonly
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="weekly-transaction-limit"
                    v-model="institutionLimitFormData.default_Customer_ATM_Weekly_Withdrawal_Limit"
                    :label="`${$t('Weekly Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.atM_Weekly_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Weekly Transaction limit')"
                    :error-name="$t('Weekly Transaction limit')"
                    :rules="`required|amount-limit:${regulatoryLimitList.atM_Weekly_Withdrawal_Limit}|default-atm-check:${institutionLimitFormData.atM_Weekly_Withdrawal_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Maximum POS Transaction Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewMaxPOSTransactiontLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="limit-per-transaction"
                    v-model.number="institutionLimitFormData.poS_Daily_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    rules="required|positive"
                    :readonly="isReadonly"
                    @input="setPOSCardLimit"
                  />
                </ValidationObserver>
              </b-col>

              <b-col md="6">
                <InputField
                  id="daily-transaction-count"
                  v-model="institutionLimitFormData.poS_Daily_Transaction_Count"
                  :label="$t('Daily Transaction Count')"
                  :placeholder="$t('Enter Daily Transaction Count')"
                  type="number"
                  :error-name="$t('Daily Transaction Count')"
                  rules="required|positive"
                  :readonly="isReadonly"
                  @input="setPOSCardCount"
                />
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model="institutionLimitFormData.poS_Daily_Withdrawal_Limit"
                    :label="`${$t('Daily Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.poS_Daily_Withdrawal_Limit * 100)})`"
                    :error-name="$t('Daily Transaction limit')"
                    :rules="`required|amount-limit:${regulatoryLimitList.poS_Daily_Withdrawal_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="pos-weekly-transaction-limit"
                    v-model="institutionLimitFormData.poS_Weekly_Withdrawal_Limit"
                    :label="`${$t('Weekly Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.poS_Weekly_Withdrawal_Limit * 100)})`"
                    :error-name="$t('Weekly Transaction limit')"
                    :rules="`required|amount-limit:${regulatoryLimitList.poS_Weekly_Withdrawal_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Customer POS Default Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewCustomerPOSDefaultLimitInfo"
              />
            </div>

            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="default-pos-single-withdrawal"
                    v-model.number="institutionLimitFormData.default_Customer_POS_Daily_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    :rules="`required|default-pos-check:${institutionLimitFormData.poS_Daily_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                    @input="setPOSDefaultCardLimit"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="daily-transaction-count"
                    v-model="institutionLimitFormData.default_Customer_POS_Daily_Transaction_Count"
                    :label="$t('Daily Transaction Count')"
                    :placeholder="$t('Enter Daily Transaction Count')"
                    type="number"
                    :error-name="$t('Daily Transaction Count')"
                    :rules="`required|default-pos-check:${institutionLimitFormData.poS_Daily_Transaction_Count}|positive`"
                    :readonly="isReadonly"
                    @input="setPOSDefaultCardCount"
                  />
                </ValidationObserver>
              </b-col>

              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model="institutionLimitFormData.default_Customer_POS_Daily_Withdrawal_Limit"
                    :label="`${$t('Daily Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.poS_Daily_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Daily Transaction limit')"
                    :error-name="$t('Daily Transaction limit')"
                    :rules="`required|amount-limit:${regulatoryLimitList.poS_Daily_Withdrawal_Limit}|default-pos-check:${institutionLimitFormData.poS_Daily_Withdrawal_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="weekly-transaction-limit"
                    v-model="institutionLimitFormData.default_Customer_POS_Weekly_Withdrawal_Limit"
                    :label="`${$t('Weekly Transaction limit - (Regulatory limit:')} ${toBalance(regulatoryLimitList.poS_Weekly_Withdrawal_Limit * 100)})`"
                    :placeholder="$t('Enter Weekly Transaction limit')"
                    :error-name="$t('Weekly Transaction limit')"
                    :rules="`required|amount-limit:${regulatoryLimitList.poS_Weekly_Withdrawal_Limit}|default-pos-check:${institutionLimitFormData.poS_Weekly_Withdrawal_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>

            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Maximum Online Transaction Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewMaxONLINEransactiontLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model.number="institutionLimitFormData.online_Daily_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    rules="required|positive"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <InputField
                  id="daily-transaction-count"
                  v-model="institutionLimitFormData.online_Daily_Transaction_Count"
                  :label="$t('Daily Transaction Count')"
                  :placeholder="$t('Enter Daily Transaction Count')"
                  type="number"
                  :error-name="$t('Daily Transaction Count')"
                  rules="required|positive"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>

            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Customer Online Default Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewCustomerOnlineDefaultLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model.number="institutionLimitFormData.default_Customer_Online_Daily_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    :rules="`required|default-online-check:${institutionLimitFormData.online_Daily_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <InputField
                  id="daily-transaction-count"
                  v-model="institutionLimitFormData.default_Customer_Online_Daily_Transaction_Count"
                  :label="$t('Daily Transaction Count')"
                  :placeholder="$t('Enter Daily Transaction Count')"
                  type="number"
                  :error-name="$t('Daily Transaction Count')"
                  :rules="`required|default-online-check:${institutionLimitFormData.online_Daily_Transaction_Count}|positive`"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </app-collapse-item>
        </app-collapse>

        <app-collapse
          class="business-items mb-4"
          type="margin"
          accordion
        >
          <app-collapse-item
            :title="$t('ACCOUNT LIMIT')"
            class="card-item"
            is-visible
          >
            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Maximum Account Transaction Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewMaxAccountransactiontLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="limit-per-transaction"
                    v-model.number="institutionLimitFormData.max_Single_Account_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    rules="required|positive"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model.number="institutionLimitFormData.max_Daily_Account_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    :rules="`required|account-limit-check:${institutionLimitFormData.max_Single_Account_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>

            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Customer Account Default Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewCustomerAccountDefaultLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="limit-per-transaction"
                    v-model.number="institutionLimitFormData.default_Max_Single_Account_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    :rules="`required|default-account-check:${institutionLimitFormData.max_Single_Account_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model.number="institutionLimitFormData.default_Max_Daily_Account_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    :rules="`required|default-account-check:${institutionLimitFormData.max_Daily_Account_Transaction_Limit}|account-limit-check:${institutionLimitFormData.default_Max_Single_Account_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Special Account Transaction Limit') }}
              </h6>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewSpecialAccountTransactionLimitInfo"
              />
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="special-limit-per-transaction"
                    v-model.number="institutionLimitFormData.specialLimit_Max_Single_Account_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Special Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    :rules="`required|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="special-daily-transaction-limit"
                    v-model.number="institutionLimitFormData.specialLimit_Max_Daily_Account_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Special Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    :rules="`required|account-limit-check:${institutionLimitFormData.specialLimit_Max_Single_Account_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
          </app-collapse-item>
        </app-collapse>

        <!-- USSD Institutions Limits -->
        <app-collapse
          class="business-items mb-4"
          type="margin"
          accordion
        >
          <app-collapse-item
            :title="$t('USSD LIMIT')"
            class="card-item"
            is-visible
          >
            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Maximum USSD Transaction Limit') }}
              </h6>
              <!-- <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewMaxAccountransactiontLimitInfo"
              /> -->
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="limit-per-transaction"
                    v-model.number="institutionLimitFormData.max_Single_USSD_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    rules="required|positive"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model.number="institutionLimitFormData.max_Daily_USSD_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    :rules="`required|account-limit-check:${institutionLimitFormData.max_Single_USSD_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Customer USSD Default Limit') }}
              </h6>
              <!-- <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewCustomerAccountDefaultLimitInfo"
              /> -->
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="limit-per-transaction"
                    v-model.number="institutionLimitFormData.default_Max_Single_USSD_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    :rules="`required|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="daily-transaction-limit"
                    v-model.number="institutionLimitFormData.default_Max_Daily_USSD_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    :rules="`required|account-limit-check:${institutionLimitFormData.default_Max_Single_USSD_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <div class="d-flex mt-3">
              <h6 class="section-label mb-1 sub-menu-title">
                {{ $t('Special USSD Transaction Limit') }}
              </h6>
              <!-- <feather-icon
                icon="InfoIcon"
                size="16"
                class="align-middle text-body ml-1"
                @click="onViewSpecialAccountTransactionLimitInfo"
              /> -->
            </div>
            <b-row>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="special-limit-per-transaction"
                    v-model.number="institutionLimitFormData.specialLimit_Max_Single_USSD_Transaction_Limit"
                    :label="$t('Limit Per Transaction')"
                    :placeholder="$t('Enter Special Limit Per Transaction')"
                    :error-name="$t('Limit Per Transaction')"
                    :rules="`required|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="special-daily-transaction-limit"
                    v-model.number="institutionLimitFormData.specialLimit_Max_Daily_USSD_Transaction_Limit"
                    :label="$t('Daily Transaction Limit')"
                    :placeholder="$t('Enter Special Daily Transaction Limit')"
                    :error-name="$t('Daily Transaction Limit')"
                    :rules="`required|account-limit-check:${institutionLimitFormData.specialLimit_Max_Single_USSD_Transaction_Limit}|positive`"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
          </app-collapse-item>
        </app-collapse>
        <!-- USSD Institutions Limits -->

        <div class="text-center">
          <Button
            :label="buttonLabel"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="saveInstitutionLimit"
          />
        </div>
      </b-form>
    </validation-observer>
    <b-modal
      id="maximum-atm-transaction-limit-modal"
      ref="maxATMTransactionLimitModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Okay')"
      @ok="hideModal('maximum-atm-transaction-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('This is the maximum limits the system would allow your customers to configure for physical ATM card transactions.') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="customer-atm-default-limit-modal"
      ref="customerATMDefaultLimitModal"
      centered
      size="md"
      ok-only
      ok-title="Okay"
      @ok="hideModal('customer-atm-default-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('When a new customer card is created, this is the limits that would be applied to the card for ATM transactions.') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="maximum-pos-transaction-limit-modal"
      ref="maxPOSTransactionLimitModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Okay')"
      @ok="hideModal('maximum-pos-transaction-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('This is the maximum limits the system would allow your customers to configure for POS card transactions.') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="customer-pos-default-limit-modal"
      ref="customerPOSDefaultLimitModal"
      centered
      size="md"
      ok-only
      ok-title="Okay"
      @ok="hideModal('customer-pos-default-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('When a new customer card is created, this is the limits that would be applied to the card for POS transactions.') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="maximum-online-transaction-limit-modal"
      ref="maxOnlineTransactionLimitModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Okay')"
      @ok="hideModal('maximum-online-transaction-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('This is the maximum limits the system would allow your customers to configure for Web/ Online card transaction.') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="customer-online-default-limit-modal"
      ref="customerOnlineDefaultLimitModal"
      centered
      size="md"
      ok-only
      ok-title="Okay"
      @ok="hideModal('customer-online-default-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('When a new customer card is created, this is the limits that would be applied to the card for Web/ Online transactions.') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="maximum-account-transaction-limit-modal"
      ref="maxAccountTransactionLimitModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Okay')"
      @ok="hideModal('maximum-account-transaction-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('This is the maximum limits the system would allow your customers to configure for account based transaction.') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="customer-account-default-limit-modal"
      ref="customerAccountDefaultLimitModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Okay')"
      @ok="hideModal('customer-account-default-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p>{{ $t('When a new customer account is created, this is the limits that would be applied to the account.') }}</p>
      </div>
    </b-modal>
    <b-modal
      id="special-account-transaction-limit-modal"
      ref="specialAccountTransactionLimitModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Okay')"
      @ok="hideModal('special-account-transaction-limit-modal')"
    >
      <div class="p-0">
        <p class="section-label mb-2">
          {{ $t('NOTE!') }}
        </p>
        <p> {{ $t('This is a custom limit for account transactions, and it is applied based on request to high volume customers who whishes to do more than the maximum limit permitted to the general customers. It can only be configured by the bank and must be done from the portal.') }} </p>
      </div>
    </b-modal>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
import { required, positive } from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import Button from '../../../../components/button/Button.vue'
import { toYearWithDate } from '../../../../../helpers/formatDate'
import { toBalance, toKobo, formatAmount } from '../../../../../helpers/formatAmount'
import { eChannelsPermission } from '../../../../../helpers/permissions'

export default {
  components: {
    Button,
    BRow,
    BCol,
    BCard,
    InputField,
    BForm,
    InputNumberField,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
  },
  mixins: [sweetAlert, permissionMixin],
  data() {
    return {
      required,
      positive,
      toBalance,
      isDisabled: false,
      isReadonly: true,
      isEditable: true,
      isLoading: false,
      showSpinner: false,
      buttonLabel: this.$t('Save'),
      actionType: 'save',
      toYearWithDate,
      institutionLimitFormData: {
        atM_Single_Withdrawal_Limit: 0,
        atM_Daily_Withdrawal_Count: 0,
        atM_Daily_Withdrawal_Limit: 0,
        atM_Weekly_Withdrawal_Limit: 0,
        poS_Daily_Withdrawal_Limit: 0,
        poS_Daily_Transaction_Count: 0,
        poS_Daily_Transaction_Limit: 0,
        poS_Weekly_Withdrawal_Limit: 0,
        online_Daily_Transaction_Limit: 0,
        online_Daily_Transaction_Count: 0,
        max_Single_Account_Transaction_Limit: 0,
        max_Daily_Account_Transaction_Limit: 0,
        default_Customer_ATM_Daily_Withdrawal_Limit: 0,
        default_Customer_ATM_Single_Withdrawal_Limit: 0,
        default_Customer_ATM_Weekly_Withdrawal_Limit: 0,
        default_Customer_ATM_Daily_Withdrawal_Count: 0,
        default_Customer_POS_Daily_Transaction_Limit: 0,
        default_Customer_POS_Daily_Withdrawal_Limit: 0,
        default_Customer_POS_Weekly_Withdrawal_Limit: 0,
        default_Customer_POS_Daily_Transaction_Count: 0,
        default_Customer_Online_Daily_Transaction_Limit: 0,
        default_Customer_Online_Daily_Transaction_Count: 0,
        default_Max_Single_Account_Transaction_Limit: 0,
        default_Max_Daily_Account_Transaction_Limit: 0,
        specialLimit_Max_Single_Account_Transaction_Limit: 0,
        specialLimit_Max_Daily_Account_Transaction_Limit: 0,

        // USSD
        max_Daily_USSD_Transaction_Limit: 0,
        default_Max_Daily_USSD_Transaction_Limit: 0,
        max_Single_USSD_Transaction_Limit: 0,
        default_Max_Single_USSD_Transaction_Limit: 0,
        specialLimit_Max_Single_USSD_Transaction_Limit: 0,
        specialLimit_Max_Daily_USSD_Transaction_Limit: 0,

      },
      regulatoryLimitList: {
        atM_Daily_Withdrawal_Limit: 0,
        atM_Single_Withdrawal_Limit: 0,
        atM_Weekly_Withdrawal_Limit: 0,
        poS_Daily_Withdrawal_Limit: 0,
        poS_Weekly_Withdrawal_Limit: 0,
      },
    }
  },
  mounted() {
    this.fetchRegulatoryLimits()
    this.fetchInstitutionLimitDetails()
  },
  methods: {
    ...mapActions({
      getRegulatoryLimits: 'eChannels/getRegulatoryLimitsList',
      getInstitutionLimitDetails: 'eChannels/getInstitutionLimitDetails',
      createInstitutionLimit: 'eChannels/createInstitutionLimit',
      updateInstitutionLimit: 'eChannels/updateInstitutionLimit',
    }),

    onViewATMTransactionLimitInfo() {
      this.$root.$emit('bv::show::modal', 'maximum-atm-transaction-limit-modal')
    },
    onViewCustomerATMDefaultLimitInfo() {
      this.$root.$emit('bv::show::modal', 'customer-atm-default-limit-modal')
    },
    onViewMaxPOSTransactiontLimitInfo() {
      this.$root.$emit('bv::show::modal', 'maximum-pos-transaction-limit-modal')
    },
    onViewCustomerPOSDefaultLimitInfo() {
      this.$root.$emit('bv::show::modal', 'customer-pos-default-limit-modal')
    },
    onViewMaxONLINEransactiontLimitInfo() {
      this.$root.$emit('bv::show::modal', 'maximum-online-transaction-limit-modal')
    },
    onViewCustomerOnlineDefaultLimitInfo() {
      this.$root.$emit('bv::show::modal', 'customer-online-default-limit-modal')
    },
    onViewMaxAccountransactiontLimitInfo() {
      this.$root.$emit('bv::show::modal', 'maximum-account-transaction-limit-modal')
    },
    onViewCustomerAccountDefaultLimitInfo() {
      this.$root.$emit('bv::show::modal', 'customer-account-default-limit-modal')
    },
    onViewSpecialAccountTransactionLimitInfo() {
      this.$root.$emit('bv::show::modal', 'special-account-transaction-limit-modal')
    },
    async fetchRegulatoryLimits() {
      try {
        this.isBusy = true
        const response = await this.getRegulatoryLimits({
          search: '',
          page: this.currentPage,
          limit: this.perPage,
          permission: eChannelsPermission.VIEW_INSTITUTION_LIMIT,
        })
        const { status, data } = response
        if (status === 200 && data.data !== null) {
          const dataValues = data.data[0]
          this.regulatoryLimitList = {
            ...dataValues,
            atM_Daily_Withdrawal_Limit: formatAmount(dataValues.atM_Daily_Withdrawal_Limit),
            atM_Single_Withdrawal_Limit: formatAmount(dataValues.atM_Single_Withdrawal_Limit),
            atM_Weekly_Withdrawal_Limit: formatAmount(dataValues.atM_Weekly_Withdrawal_Limit),
            poS_Daily_Withdrawal_Limit: formatAmount(dataValues.poS_Daily_Withdrawal_Limit),
            poS_Weekly_Withdrawal_Limit: formatAmount(dataValues.poS_Weekly_Withdrawal_Limit),
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async fetchInstitutionLimitDetails() {
      try {
        this.showSpinner = true
        const response = await this.getInstitutionLimitDetails({
          permission: eChannelsPermission.VIEW_INSTITUTION_LIMIT,
        })

        const { status, data } = await response
        if (status === 200 && data) {
          this.institutionLimitFormData = {
            atM_Single_Withdrawal_Limit: formatAmount(data.atM_Single_Withdrawal_Limit),
            atM_Daily_Withdrawal_Limit: formatAmount(data.atM_Daily_Withdrawal_Limit),
            atM_Daily_Withdrawal_Count: Number(data.atM_Daily_Withdrawal_Count),
            atM_Weekly_Withdrawal_Limit: formatAmount(data.atM_Weekly_Withdrawal_Limit),
            poS_Daily_Transaction_Limit: formatAmount(data.poS_Daily_Transaction_Limit),
            poS_Daily_Withdrawal_Limit: formatAmount(data.poS_Daily_Withdrawal_Limit),
            poS_Daily_Transaction_Count: Number(data.poS_Daily_Transaction_Count),
            poS_Weekly_Withdrawal_Limit: formatAmount(data.poS_Weekly_Withdrawal_Limit),
            online_Daily_Transaction_Limit: formatAmount(data.online_Daily_Transaction_Limit),
            online_Daily_Transaction_Count: Number(data.online_Daily_Transaction_Count),
            max_Single_Account_Transaction_Limit: formatAmount(data.max_Single_Account_Transaction_Limit),
            max_Daily_Account_Transaction_Limit: formatAmount(data.max_Daily_Account_Transaction_Limit),
            default_Customer_ATM_Daily_Withdrawal_Limit: formatAmount(data.default_Customer_ATM_Daily_Withdrawal_Limit),
            default_Customer_ATM_Single_Withdrawal_Limit: formatAmount(data.default_Customer_ATM_Single_Withdrawal_Limit),
            default_Customer_ATM_Weekly_Withdrawal_Limit: formatAmount(data.default_Customer_ATM_Weekly_Withdrawal_Limit),
            default_Customer_ATM_Daily_Withdrawal_Count: Number(data.default_Customer_ATM_Daily_Withdrawal_Count),
            default_Customer_POS_Daily_Transaction_Limit: formatAmount(data.default_Customer_POS_Daily_Transaction_Limit),
            default_Customer_POS_Daily_Withdrawal_Limit: formatAmount(data.default_Customer_POS_Daily_Withdrawal_Limit),
            default_Customer_POS_Weekly_Withdrawal_Limit: formatAmount(data.default_Customer_POS_Weekly_Withdrawal_Limit),
            default_Customer_POS_Daily_Transaction_Count: Number(data.default_Customer_POS_Daily_Transaction_Count),
            default_Customer_Online_Daily_Transaction_Limit: formatAmount(data.default_Customer_Online_Daily_Transaction_Limit),
            default_Customer_Online_Daily_Transaction_Count: Number(data.default_Customer_Online_Daily_Transaction_Count),
            default_Max_Single_Account_Transaction_Limit: formatAmount(data.default_Max_Single_Account_Transaction_Limit),
            default_Max_Daily_Account_Transaction_Limit: formatAmount(data.default_Max_Daily_Account_Transaction_Limit),
            specialLimit_Max_Single_Account_Transaction_Limit: formatAmount(data.specialLimit_Max_Single_Account_Transaction_Limit),
            specialLimit_Max_Daily_Account_Transaction_Limit: formatAmount(data.specialLimit_Max_Daily_Account_Transaction_Limit),
            // USSD
            max_Daily_USSD_Transaction_Limit: formatAmount(data.max_Daily_USSD_Transaction_Limit),
            default_Max_Daily_USSD_Transaction_Limit: formatAmount(data.default_Max_Daily_USSD_Transaction_Limit),
            max_Single_USSD_Transaction_Limit: formatAmount(data.max_Single_USSD_Transaction_Limit),
            default_Max_Single_USSD_Transaction_Limit: formatAmount(data.default_Max_Single_USSD_Transaction_Limit),
            specialLimit_Max_Single_USSD_Transaction_Limit: formatAmount(data.specialLimit_Max_Single_USSD_Transaction_Limit),
            specialLimit_Max_Daily_USSD_Transaction_Limit: formatAmount(data.specialLimit_Max_Daily_USSD_Transaction_Limit),

          }
          this.showSpinner = false
          this.buttonLabel = this.$t('Edit')
          this.actionType = 'edit'
        } else {
          this.actionType = 'save'
          this.isReadonly = false
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    saveInstitutionLimit() {
      if (this.buttonLabel === this.$t('Save Changes')) {
        this.$refs.institutionLimitRules.validate().then(success => {
          if (success) {
            this.confirm(this.institutionLimitSubmit, { text: this.$t('Are you sure you want to Update this Institution Limit?') })
          }
        })
      } else {
        this.isReadonly = false
        this.buttonLabel = this.$t('Save Changes')
      }
    },
    async institutionLimitSubmit() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          atM_Single_Withdrawal_Limit: toKobo(this.institutionLimitFormData.atM_Single_Withdrawal_Limit),
          atM_Daily_Withdrawal_Count: Number(this.institutionLimitFormData.atM_Daily_Withdrawal_Count),
          atM_Daily_Withdrawal_Limit: toKobo(this.institutionLimitFormData.atM_Daily_Withdrawal_Limit),
          atM_Weekly_Withdrawal_Limit: toKobo(this.institutionLimitFormData.atM_Weekly_Withdrawal_Limit),
          poS_Daily_Transaction_Limit: toKobo(this.institutionLimitFormData.poS_Daily_Transaction_Limit),
          poS_Daily_Transaction_Count: Number(this.institutionLimitFormData.poS_Daily_Transaction_Count),
          poS_Daily_Withdrawal_Limit: toKobo(this.institutionLimitFormData.poS_Daily_Withdrawal_Limit),
          poS_Weekly_Withdrawal_Limit: toKobo(this.institutionLimitFormData.poS_Weekly_Withdrawal_Limit),
          online_Daily_Transaction_Limit: toKobo(this.institutionLimitFormData.online_Daily_Transaction_Limit),
          online_Daily_Transaction_Count: Number(this.institutionLimitFormData.online_Daily_Transaction_Count),
          max_Single_Account_Transaction_Limit: toKobo(this.institutionLimitFormData.max_Single_Account_Transaction_Limit),
          max_Daily_Account_Transaction_Limit: toKobo(this.institutionLimitFormData.max_Daily_Account_Transaction_Limit),
          default_Customer_ATM_Daily_Withdrawal_Limit: toKobo(this.institutionLimitFormData.default_Customer_ATM_Daily_Withdrawal_Limit),
          default_Customer_ATM_Single_Withdrawal_Limit: toKobo(this.institutionLimitFormData.default_Customer_ATM_Single_Withdrawal_Limit),
          default_Customer_ATM_Weekly_Withdrawal_Limit: toKobo(this.institutionLimitFormData.default_Customer_ATM_Weekly_Withdrawal_Limit),
          default_Customer_ATM_Daily_Withdrawal_Count: Number(this.institutionLimitFormData.default_Customer_ATM_Daily_Withdrawal_Count),
          default_Customer_POS_Daily_Transaction_Limit: toKobo(this.institutionLimitFormData.default_Customer_POS_Daily_Transaction_Limit),
          default_Customer_POS_Daily_Withdrawal_Limit: toKobo(this.institutionLimitFormData.default_Customer_POS_Daily_Withdrawal_Limit),
          default_Customer_POS_Weekly_Withdrawal_Limit: toKobo(this.institutionLimitFormData.default_Customer_POS_Weekly_Withdrawal_Limit),
          default_Customer_POS_Daily_Transaction_Count: Number(this.institutionLimitFormData.default_Customer_POS_Daily_Transaction_Count),
          default_Customer_Online_Daily_Transaction_Limit: toKobo(this.institutionLimitFormData.default_Customer_Online_Daily_Transaction_Limit),
          default_Customer_Online_Daily_Transaction_Count: Number(this.institutionLimitFormData.default_Customer_Online_Daily_Transaction_Count),
          default_Max_Single_Account_Transaction_Limit: toKobo(this.institutionLimitFormData.default_Max_Single_Account_Transaction_Limit),
          default_Max_Daily_Account_Transaction_Limit: toKobo(this.institutionLimitFormData.default_Max_Daily_Account_Transaction_Limit),
          // Maximum
          atM_Maximum_Daily_Withdrawal_Limit: toKobo(this.institutionLimitFormData.atM_Daily_Withdrawal_Limit),
          atM_Maximum_Single_Withdrawal_Limit: toKobo(this.institutionLimitFormData.atM_Single_Withdrawal_Limit),
          atM_Maximum_Daily_Withdrawal_Count: Number(this.institutionLimitFormData.atM_Daily_Withdrawal_Count),
          atM_Maximum_Weekly_Withdrawal_Limit: toKobo(this.institutionLimitFormData.atM_Weekly_Withdrawal_Limit),
          poS_Maximum_Daily_Transaction_Limit: toKobo(this.institutionLimitFormData.poS_Daily_Transaction_Limit),
          poS_Maximum_Daily_Transaction_Count: Number(this.institutionLimitFormData.poS_Daily_Transaction_Count),
          poS_Maximum_Daily_Withdrawal_Limit: toKobo(this.institutionLimitFormData.poS_Daily_Withdrawal_Limit),
          poS_Maximum_Weekly_Withdrawal_Limit: toKobo(this.institutionLimitFormData.poS_Weekly_Withdrawal_Limit),
          online_Maximum_Daily_Transaction_Limit: toKobo(this.institutionLimitFormData.online_Daily_Transaction_Limit),
          online_Maximum_Daily_Transaction_Count: Number(this.institutionLimitFormData.online_Daily_Transaction_Count),

          // SPECIAL
          specialLimit_Max_Single_Account_Transaction_Limit: toKobo(this.institutionLimitFormData.specialLimit_Max_Single_Account_Transaction_Limit),
          specialLimit_Max_Daily_Account_Transaction_Limit: toKobo(this.institutionLimitFormData.specialLimit_Max_Daily_Account_Transaction_Limit),

          // USSD
          max_Daily_USSD_Transaction_Limit: toKobo(this.institutionLimitFormData.max_Daily_USSD_Transaction_Limit),
          default_Max_Daily_USSD_Transaction_Limit: toKobo(this.institutionLimitFormData.default_Max_Daily_USSD_Transaction_Limit),
          max_Single_USSD_Transaction_Limit: toKobo(this.institutionLimitFormData.max_Single_USSD_Transaction_Limit),
          default_Max_Single_USSD_Transaction_Limit: toKobo(this.institutionLimitFormData.default_Max_Single_USSD_Transaction_Limit),
          specialLimit_Max_Single_USSD_Transaction_Limit: toKobo(this.institutionLimitFormData.specialLimit_Max_Single_USSD_Transaction_Limit),
          specialLimit_Max_Daily_USSD_Transaction_Limit: toKobo(this.institutionLimitFormData.specialLimit_Max_Daily_USSD_Transaction_Limit),

        }
        const response = this.actionType === 'save'
          ? await this.createInstitutionLimit({
            formData,
            permission: eChannelsPermission.CREATE_INSTITUTION_LIMIT,
          })
          : await this.updateInstitutionLimit({
            formData,
            permission: eChannelsPermission.UPDATE_INSTITUTION_LIMIT,
          })

        const { status } = await response
        if (status === 200) {
          const requestText = this.$t('Your request to')
          const text1 = this.$t('in Institution Limit was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonLabel} ${text1}` })
          this.isReadonly = true
          this.isEditable = true
          this.isDisabled = false
          this.isLoading = false
          this.buttonLabel = this.$t('Edit')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isEditable = true
        this.isDisabled = false
        this.isLoading = false
      }
    },
    setATMCardLimit(value) {
      this.institutionLimitFormData.atM_Daily_Withdrawal_Limit = value * this.institutionLimitFormData.atM_Daily_Withdrawal_Count
    },
    setATMCardCount(value) {
      this.institutionLimitFormData.atM_Daily_Withdrawal_Limit = this.institutionLimitFormData.atM_Single_Withdrawal_Limit * value
    },
    setATMDefaultCardLimit(value) {
      this.institutionLimitFormData.default_Customer_ATM_Daily_Withdrawal_Limit = value * this.institutionLimitFormData.default_Customer_ATM_Daily_Withdrawal_Count
    },
    setATMDefaultCardCount(value) {
      this.institutionLimitFormData.default_Customer_ATM_Daily_Withdrawal_Limit = this.institutionLimitFormData.default_Customer_ATM_Single_Withdrawal_Limit * value
    },
    setPOSCardLimit(value) {
      this.institutionLimitFormData.poS_Daily_Withdrawal_Limit = value * this.institutionLimitFormData.poS_Daily_Transaction_Count
    },
    setPOSCardCount(value) {
      this.institutionLimitFormData.poS_Daily_Withdrawal_Limit = this.institutionLimitFormData.poS_Daily_Transaction_Limit * value
    },
    setPOSDefaultCardLimit(value) {
      this.institutionLimitFormData.default_Customer_POS_Daily_Withdrawal_Limit = value * this.institutionLimitFormData.default_Customer_POS_Daily_Transaction_Count
    },
    setPOSDefaultCardCount(value) {
      this.institutionLimitFormData.default_Customer_POS_Daily_Withdrawal_Limit = this.institutionLimitFormData.default_Customer_POS_Daily_Transaction_Limit * value
    },
  },
}
</script>
<style scoped>
.custom-checkbox:last-child{
    margin-left: 20px !important;
}
.sub-menu-title {
  font-size: 14px;
  font-weight: 500;
}

</style>
